import React, { useState, useEffect } from 'react'
import {
  Spin,
  Form,
  Input,
  Collapse,
  InputNumber,
  Row,
  Col,
  Tooltip,
  message,
  Button,
  Popover,
  List,
  Avatar
} from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { InputGroup } from 'reactstrap'
import {
  loadSaleProductJsonData,
  loadIsDiscardSale,
  loadShowInventoryPopup,
  loadActionLogs,
  loadShowNumPad,
  loadNumPadType,
  loadNumRelateData
} from '../../appRedux/actions/Sell'
import {
  isEmptyObject,
  StringIsNullOrEmpty,
  getDecryptID,
  clusterCalculations,
  fetchCurrentSalesOrder,
  formatDigits,
  customParse,
  parseFloatCustom,
  closingNumPad
} from '../../appRedux/actions/GlobalMethods'
import { SellProductJsonBuilder } from '../../appRedux/actions/SellScreenMethods'
import {
  loadRowDataUpdated,
  loadDeletedProds
} from '../../appRedux/actions/MainSale'
import {
  calculateExplicitDisc,
  calculateExplicitPrice,
  calculateExplicitQuantity
} from '../../appRedux/actions/ProdHelperMethods'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import { MinusOutlined, PlusOutlined, WarningOutlined } from '@ant-design/icons'
import { SALE_ACTION_LOG } from '../../constants/StoreSetting'
import { isMobile } from 'react-device-detect'
import { NumPadTypes } from '../../constants/MobAppConstants'
import NumPad from './NumPad'

const ProductObj = props => {
  const { discountPerm, key, data, callback, availableUsers } = props
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const Panel = Collapse.Panel

  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getStoredBooks = useSelector(({ Sell }) => Sell.salePriceBooks)
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const getDefaultLoyaltyAmount = useSelector(
    ({ MainSale }) => MainSale.getDefaultLoyaltyAmount
  )
  const getStoredPromos = useSelector(({ Sell }) => Sell.salePromotions)
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getSelectedReg = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedReggg
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getIsRefundNeg = useSelector(({ MainSale }) => MainSale.getIsRefundNeg)
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)
  const getIsOutInvWarn = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsOutInvWarn
  )
  const isDisableCart = useSelector(({ MainSale }) => MainSale.isDisableCart)
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)
  const numDataChange = useSelector(({ Sell }) => Sell.numDataChange)
  const numPadData = useSelector(({ Sell }) => Sell.numPadData)
  const numPadType = useSelector(({ Sell }) => Sell.numPadType)
  const isRowDataUpdated = useSelector(
    ({ MainSale }) => MainSale.isRowDataUpdated
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const showNumPad = useSelector(({ Sell }) => Sell.showNumPad)
  const showInventoryPopup = useSelector(({ Sell }) => Sell.showInventoryPopup)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getAmount, setAmount] = useState('')
  const [getDiscount, setDiscount] = useState('')
  const [prevDiscount, setPrevDiscount] = useState(0)
  const [prevAmount, setPrevAmount] = useState(0)
  const [width, setWidth] = useState(window.innerWidth)
  const [selectedUser, setSelectedUser] = useState({})
  const [popoverVisible, setPopoverVisible] = useState(false)

  useEffect(() => {
    let mounted = true
    if (
      mounted &&
      isEmptyObject(selectedUser) &&
      !isEmptyObject(getReduxStoreInfo)
    ) {
      const body = {
        name: getReduxStoreInfo.userName,
        id: getReduxStoreInfo.userID
      }
      setSelectedUser(body)
    }
    return () => {
      mounted = false
    }
  }, [getReduxStoreInfo])

  useEffect(() => {
    let mounted = true
    if (mounted && !isEmptyObject(data)) {
      let val = 0
      const quantity = data.displayQuantity ? data.displayQuantity : 1
      if (getIsTaxExclusive) {
        const value =
          data.totals && data.totals.exclusivePrice
            ? data.totals.exclusivePrice / quantity
            : 0
        val = value ? formatDigits(value, getDefaultDecimalPlaces) : '0.00'
      } else {
        const valueInc =
          data.totals && data.totals.inclusivePrice
            ? data.totals.inclusivePrice / quantity
            : 0
        val = valueInc
          ? formatDigits(valueInc, getDefaultDecimalPlaces)
          : '0.00'
      }
      const disVal =
        data.displayDiscountPercent != undefined
          ? formatDigits(data.displayDiscountPercent, getDefaultDecimalPlaces)
          : '0.00'
      setAmount(val)
      setDiscount(disVal)
      setPrevAmount(parseFloatCustom(val))
      setPrevDiscount(parseFloatCustom(disVal))
      form.setFieldsValue({
        [`ProductNotes${data.key}`]: data.productNote ? data.productNote : ''
      })
    }

    return () => (mounted = false)
  }, [data])

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  useEffect(() => {
    let mounted = true
    if (
      mounted &&
      numDataChange &&
      // numDataChange > 0 &&
      numPadData &&
      !isEmptyObject(numPadData) &&
      numPadType &&
      numPadType > 0
    ) {
      const inputNmbr = numDataChange == 'zero' ? 0 : numDataChange
      let type =
        numPadType == 1
          ? 'ProductQuantity'
          : numPadType == 2
          ? 'ProductRetailPrice'
          : numPadType == 3
          ? 'ProductDiscount'
          : false
      if (type) {
        handleChangeProductRowFields(
          numPadType == 1
            ? inputNmbr
            : numPadType == 2 || numPadType == 3
            ? { target: { value: inputNmbr } }
            : inputNmbr,
          type,
          numPadData.key,
          key,
          true
        )
        const prodKey = type
          ? `${numPadType == 2 ? 'ProductPrice' : type}${numPadData.key}`
          : false
        if (prodKey) {
          form.setFieldsValue({ [prodKey]: inputNmbr })
        }
        if (numPadType == 2) {
          // for price
          setAmount(formatDigits(inputNmbr, getDefaultDecimalPlaces))
          setActionLog(
            inputNmbr,
            numPadData.key,
            SALE_ACTION_LOG.ItemPriceAdjustment,
            numPadData.productName
          )
        } else if (numPadType == 3) {
          // for discount
          setDiscount(formatDigits(inputNmbr, getDefaultDecimalPlaces))
          setActionLog(
            inputNmbr,
            numPadData.key,
            SALE_ACTION_LOG.ItemDiscount,
            numPadData.productName
          )
        }
        closingNumPad(dispatch)
      }
    }

    return () => (mounted = false)
  }, [numDataChange])

  function handleWindowSizeChange () {
    setWidth(window.innerWidth)
  }

  const handleDeleteProduct = productKey => {
    const logData =
      sellActionLog && sellActionLog.length > 0
        ? sellActionLog.filter(a => a.key != productKey)
        : []
    dispatch(loadActionLogs(logData))
    let deleteProd = getReduxSaleProductJsonData.filter(
      prodObj => prodObj.key === productKey
    )
    if (deleteProd && deleteProd.length > 0) {
      deleteProd = deleteProd[0]
      if (deleteProd.sSalesOrderItemID && deleteProd.sSalesOrderItemID != '') {
        dispatch(
          loadDeletedProds(getDeletedProds.concat(deleteProd.sSalesOrderItemID))
        )
      }
    }
    const updatedProductData = getReduxSaleProductJsonData.filter(
      prodObj => prodObj.key !== productKey
    )

    if (updatedProductData && updatedProductData.length > 0) {
      let sProducts = updatedProductData
      updatedProductData.map(prod => {
        const productsClone = SellProductJsonBuilder(
          prod,
          undefined,
          '',
          getCustomerSearchData,
          updatedProductData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'handleDeleteProduct',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            sProducts.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = sProducts.indexOf(
              sProducts.filter(a => a.key == productsClone.key)[0]
            )
            sProducts[index] = productsClone
          } else {
            sProducts = sProducts.concat(productsClone)
          }
        }
      })
      clusterCalculations(
        sProducts,
        getSelectedOutlet,
        getSelectedReg,
        getBasicIsPercent,
        getCustomerSearchData,
        getIsRefundSale,
        getDefaultDecimalPlaces,
        getCurrentSalesOrderData,
        getCurrentSalesOrderStatusID,
        formDiscCurr,
        formDiscPer,
        formSellNote,
        getRefundKeys,
        getSalePayments,
        dispatch,
        getStoredPromos,
        getIsTaxExclusive,
        false,
        getSavings,
        sellSelAttributes
      )
    } else {
      dispatch(loadIsDiscardSale('1'))
    }

    // check for inv to remove if its last neg inv prod in list
    if (showInventoryPopup) {
      const negInv = getReduxSaleProductJsonData.filter(
        p => p.negativeInventory
      )
      if (negInv && negInv.length == 1) {
        dispatch(loadShowInventoryPopup(false))
      }
    }
  }

  const handleChangeProductRowFields = (
    event,
    inputType,
    productKey,
    rowKey,
    fromNumPad
  ) => {
    let rowName = productKey
    let items = [...getReduxSaleProductJsonData]
    let item = { ...items.filter(a => a.key === rowName)[0] }
    if (!isEmptyObject(item)) {
      if (inputType == 'ProductQuantity') {
        const quantity = event
        if (item.isRowDataPoke && !item.isPromotionApplied) {
          const appliedQuantiy = calculateExplicitQuantity(
            item,
            quantity,
            getIsTaxExclusive
          )
          item = appliedQuantiy.item
        } else {
          item.displayQuantity = quantity
        }
        let productsss = getReduxSaleProductJsonData
        const productsClone = SellProductJsonBuilder(
          item,
          undefined,
          '',
          getCustomerSearchData,
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'handleChangeProductRowFields',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            productsss.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = productsss.indexOf(
              productsss.filter(a => a.key == productsClone.key)[0]
            )
            productsss[index] = productsClone
          } else {
            productsss = productsss.concat(productsClone)
          }
        }
        clusterCalculations(
          productsss,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
      } else if (inputType == 'ProductRetailPrice') {
        const retailPrice = event.target.value
        const appliedPrice = calculateExplicitPrice(
          item,
          retailPrice,
          getIsTaxExclusive
        )
        item = appliedPrice.item
        let index = items.indexOf(items.filter(a => a.key == rowName)[0])
        items[index] = item

        let productsFidler = items
        items.map(prod => {
          const productsClone = SellProductJsonBuilder(
            prod,
            undefined,
            '',
            getCustomerSearchData,
            items,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscCurr,
            formDiscPer,
            formSellNote,
            getRefundKeys,
            getSalePayments,
            dispatch,
            false,
            getSavings,
            'handleChangeProductRowFields',
            true,
            sellSelAttributes
          )
          if (productsClone && !isEmptyObject(productsClone)) {
            if (
              productsClone.key &&
              productsFidler.filter(a => a.key === productsClone.key)[0]
            ) {
              let index = productsFidler.indexOf(
                productsFidler.filter(a => a.key == productsClone.key)[0]
              )
              productsFidler[index] = productsClone
            } else {
              productsFidler = productsFidler.concat(productsClone)
            }
          }
        })
        clusterCalculations(
          productsFidler,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
      } else if (inputType == 'ProductDiscount') {
        const discount = event.target.value
          ? event.target.value
          : 0
          ? customParse(event.target.value)
          : 0
        const appliedDisc = calculateExplicitDisc(
          item,
          discount,
          getIsTaxExclusive
        )
        item = appliedDisc.item
        const index = items.indexOf(items.filter(a => a.key == rowName)[0])
        items[index] = item

        let fiddlerProds = items
        items.map(prod => {
          const productsClone = SellProductJsonBuilder(
            prod,
            undefined,
            '',
            getCustomerSearchData,
            items,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscCurr,
            formDiscPer,
            formSellNote,
            getRefundKeys,
            getSalePayments,
            dispatch,
            false,
            getSavings,
            'handleChangeProductRowFields',
            true,
            sellSelAttributes
          )
          if (productsClone && !isEmptyObject(productsClone)) {
            if (
              productsClone.key &&
              fiddlerProds.filter(a => a.key === productsClone.key)[0]
            ) {
              let index = fiddlerProds.indexOf(
                fiddlerProds.filter(a => a.key == productsClone.key)[0]
              )
              fiddlerProds[index] = productsClone
            } else {
              fiddlerProds = fiddlerProds.concat(productsClone)
            }
          }
        })
        clusterCalculations(
          fiddlerProds,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
      } else if (inputType == 'ProductNotes') {
        item.productNote = event.target.value
        let bckupProds = getReduxSaleProductJsonData
        const productsClone = SellProductJsonBuilder(
          item,
          undefined,
          '',
          getCustomerSearchData,
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'handleChangeProductRowFields',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            bckupProds.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = bckupProds.indexOf(
              bckupProds.filter(a => a.key == productsClone.key)[0]
            )
            bckupProds[index] = productsClone
          } else {
            bckupProds = bckupProds.concat(productsClone)
          }
        }
        clusterCalculations(
          bckupProds,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
      }
    }
  }

  function invContAnyway () {
    let prods = getReduxSaleProductJsonData
    prods.map(a => {
      a.inventoryCheck = false
      a.negativeInventory = false
    })
    dispatch(loadShowInventoryPopup(false))
    dispatch(loadSaleProductJsonData(prods))
  }

  function setActionLog (value, key, identify, productName) {
    const comment = `The ${
      identify == SALE_ACTION_LOG.ItemDiscount ? 'Discount' : 'Price'
    } of product ${productName} was adjusted from ${
      identify == SALE_ACTION_LOG.ItemDiscount ? prevDiscount : prevAmount
    } to ${value}. Created by ${
      getReduxStoreInfo && getReduxStoreInfo.userName
        ? getReduxStoreInfo.userName
        : 'XXX'
    } with userID of ${
      getReduxStoreInfo && getReduxStoreInfo.userID
        ? getDecryptID(getReduxStoreInfo.userID)
        : ''
    }`
    const body = {
      ActionBy:
        getReduxStoreInfo && getReduxStoreInfo.userID
          ? getReduxStoreInfo.userID
          : '',
      Comment: comment,
      FromValue:
        identify == SALE_ACTION_LOG.ItemDiscount ? prevDiscount : prevAmount,
      ToValue: parseFloatCustom(value),
      SaleActionLogTypeId: `${identify}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
      key: key
    }
    const data =
      sellActionLog && sellActionLog.length > 0
        ? sellActionLog.filter(a => a.key != key)
        : []
    dispatch(loadActionLogs(data.concat(body)))
  }

  function clickForNumPad (type, data) {
    // 1 for quantity, 2 for price, 3 for discount, 4 for customers, 5 for amount to pay
    dispatch(loadShowNumPad(true))
    dispatch(loadNumPadType(type))
    dispatch(loadNumRelateData(data))
    // if (type && type == 1) {
    //   dispatch(loadShowNumPad(true))
    //   dispatch(loadNumPadType(type))
    //   dispatch(loadNumRelateData(data))
    // } else if (type && type == 2) {
    // } else if (type && type == 3) {
    // }
  }

  function quantityOperate (type, quantity, inputType, productKey) {
    let quant = parseInt(quantity)
    let exec = false
    if (quant || type == 'plus') {
      if (type == 'plus') {
        quant += 1
        exec = true
      } else if (type == 'minus') {
        if (getIsRefundSale) {
          quant = quant == 1 ? quant - 2 : quant - 1
        } else {
          quant = quant != 1 ? quant - 1 : quant
        }
        exec = true
      }

      if (exec) {
        handleChangeProductRowFields(quant, inputType, productKey)
      }
    }
  }

  function onUserClick (user) {
    if (user && user.id) {
      let rowName = data.key
      let items = [...getReduxSaleProductJsonData]
      let item = { ...items.filter(a => a.key === rowName)[0] }
      if (!isEmptyObject(item)) {
        item.userID = getDecryptID(user.id)
        let bckupProds = getReduxSaleProductJsonData
        const productsClone = SellProductJsonBuilder(
          item,
          undefined,
          '',
          getCustomerSearchData,
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'handleChangeProductRowFields',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            bckupProds.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = bckupProds.indexOf(
              bckupProds.filter(a => a.key == productsClone.key)[0]
            )
            bckupProds[index] = productsClone
          } else {
            bckupProds = bckupProds.concat(productsClone)
          }
        }
        clusterCalculations(
          bckupProds,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
      }
      setPopoverVisible(false)
    }
  }

  const content = (
    <div className='theme-scroll scroll-height-3'>
      <List
        itemLayout='horizontal'
        dataSource={availableUsers}
        renderItem={(user, index) => {
          const isEven = index % 2 === 0
          return (
            <List.Item
              onClick={() => onUserClick(user)}
              style={{ cursor: 'pointer' }}
            >
              <List.Item.Meta
                avatar={
                  user.profilePic ? (
                    <Avatar
                      src={user.profilePic}
                      className='gx-avatar gx-pointer'
                      alt=''
                    />
                  ) : (
                    <Avatar
                      style={{
                        fontWeight: 'bold',
                        cursor: 'pointer'
                      }}
                      className={`gx-avatar gx-bg-${isEven ? 'green' : 'blue'}`}
                      src={user.profilePic ? user.profilePic : ''}
                      size={'large'}
                    >
                      {!user.profilePic &&
                        `${
                          user.firstName
                            ? user.firstName.charAt(0).toUpperCase()
                            : ''
                        }${
                          user.lastName
                            ? user.lastName.charAt(0).toUpperCase()
                            : ''
                        }`}
                    </Avatar>
                  )
                }
                title={
                  <h3>
                    {user.firstName + ' ' + user.lastName}
                  </h3>
                }
                description={`${user.roleName ? user.roleName : ''}`}
              />
            </List.Item>
          )
        }}
      />
    </div>
  )

  return (
    <Collapse
      // onChange={callback}
      onChange={e => {
        // const a = e;
        //
        // dispatch(loadShowNumPad(true))
      }}
      accordion
      className='cart-item'
    >
      {showNumPad && <NumPad from='product' />}
      <Panel
        className='custom-ant-collapse-item'
        header={
          <div className='gx-module-list-item'>
            <div className='gx-module-list-icon'>
              <div
                className={
                  data.isRefund && !StringIsNullOrEmpty(data.sSalesOrderItemID)
                    ? 'pro-quantity gx-text-danger'
                    : 'pro-quantity'
                }
              >
                <Button
                  icon={<MinusOutlined />}
                  onClick={e => {
                    e.stopPropagation() // for stopping the panel to expand
                    if (!data.isOnAccount) {
                      quantityOperate(
                        'minus',
                        data.displayQuantity,
                        'ProductQuantity',
                        data.key,
                        key
                      )
                    }
                  }}
                />
                <span
                  onClick={e => {
                    e.stopPropagation() // for stopping the panel to expand
                    if (!data.isOnAccount) {
                      clickForNumPad(NumPadTypes.QUANTITY, data)
                    }
                  }}
                >
                  {getDecryptID(getCurrentSalesOrderStatusID) ==
                    getDecryptID(
                      fetchCurrentSalesOrder('Delivery, unfulfilled')
                    ) ||
                  getDecryptID(getCurrentSalesOrderStatusID) ==
                    getDecryptID(
                      fetchCurrentSalesOrder('PickUp, unfulfilled')
                    ) ? (
                    `0/${data.displayQuantity}`
                  ) : data.negativeInventory ? (
                    <WarningOutlined style={{ color: 'red', marginLeft: 12 }} />
                  ) : (
                    data.displayQuantity
                  )}
                </span>
                <Button
                  icon={<PlusOutlined />}
                  onClick={e => {
                    e.stopPropagation() // for stopping the panel to expand
                    if (!data.isOnAccount) {
                      quantityOperate(
                        'plus',
                        data.displayQuantity,
                        'ProductQuantity',
                        data.key,
                        key
                      )
                    }
                  }}
                />
              </div>
            </div>
            <div className='txt-ellipsis'>
              <div className={`sell-product-text`}>
                <span className='productName'>{data.productName}</span>
                <div className='gx-manage-margin sell-promotion-text'>
                  {data.isPromotionApplied &&
                  data.PromotionandPriceBookDetails &&
                  data.PromotionandPriceBookDetails.lineItemPromotions ? (
                    <i className='icon icon-tickets custom-pd-right-4' />
                  ) : (
                    ''
                  )}

                  <span>
                    {' '}
                    {data.isPromotionApplied &&
                      data.PromotionandPriceBookDetails &&
                      data.PromotionandPriceBookDetails.lineItemPromotions &&
                      data.PromotionandPriceBookDetails.lineItemPromotions
                        .promotionName}
                  </span>
                </div>
              </div>
            </div>

            <div className='gx-module-list-info'>
              <div className='gx-module-todo-content custom-mg-left cart-item-price-div'>
                <div className={`sell-product-text float-right`}>
                  <span
                    onClick={e => {
                      e.stopPropagation() // for stopping the panel to expand
                      clickForNumPad(NumPadTypes.PRICE, data)
                    }}
                  >
                    {data.totals && data.totals.displayPrice != undefined
                      ? formatDigits(
                          data.totals.displayPrice,
                          getDefaultDecimalPlaces
                        )
                      : ''}
                  </span>
                  <div className='gx-manage-margin sell-promotion-text'>
                    <span className='gx-text-muted gx-px-2'>
                      {' '}
                      {data.totals &&
                      !isEmptyObject(data.totals) &&
                      customParse(
                        data.totals.displayBasePrice *
                          (data.totals.displayBasePrice < 0 ? -1 : 1)
                      ) >
                        customParse(
                          data.totals.displayPrice *
                            (data.totals.displayPrice < 0 ? -1 : 1)
                        ) ? (
                        <del>
                          {formatDigits(
                            data.totals.displayBasePrice,
                            getDefaultDecimalPlaces
                          )}{' '}
                        </del>
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className='gx-module-todo-right del-btn-div'>
                <span>
                  {data.isOnAccount ? (
                    <LockOutlined />
                  ) : (
                    <a
                      className='trash-icon-btn'
                      onClick={() => handleDeleteProduct(data.key)}
                    >
                      <i className='icon icon-trash' />
                    </a>
                  )}
                </span>
              </div>
            </div>
          </div>
        }
        key={key}
      >
        <Form
          // {...formItemLayout}
          form={form}
          name='cartForm'
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          initialValues={{
            prefix: '86'
          }}
          scrollToFirstError
        >
          <InputGroup size='large' className='gx-mb-3 disp-table'>
            <Form.Item
              className='ant-form-item-label-custom  disp-table-cell Sub-ProductQuantity Quantity-cross'
              label={<IntlMessages id='sell.sell.quantity' />}
              rules={[
                {
                  required: true,
                  message: 'Please enter  product quantity'
                }
              ]}
              name={`ProductQuantity${data.key}`}
              hasFeedback
              {...{
                // help: data.negativeInventory ? "Minimum length should be 8 characters" : "",
                hasFeedback: true,
                validateStatus: data.negativeInventory ? 'error' : ''
              }}
              style={{ textAlign: 'center', background: '#f3f3f3' }}
            >
              <Tooltip title='Click to change quantity' color='#6f6e6e'>
                <Row
                  justify='center'
                  onClick={() => {
                    if (!data.isOnAccount)
                      clickForNumPad(NumPadTypes.QUANTITY, data)
                  }}
                >
                  <Col style={{ cursor: 'pointer' }}>
                    {data.displayQuantity}
                  </Col>
                </Row>
                {/* <InputNumber
                defaultValue={data.displayQuantity}
                step={1}
                style={{ width: '100%' }}
                onChange={e => {
                  handleChangeProductRowFields(
                    e,
                    'ProductQuantity',
                    data.key,
                    key
                  )
                }}
                disabled={data.isOnAccount}
                onFocus={e => e.target.select()}
              /> */}
              </Tooltip>
            </Form.Item>
            <Form.Item
              className='ant-form-item-label-custom  disp-table-cell Sub-ProductQuantity'
              name={`ProductPrice${data.key}`}
              label={<IntlMessages id='sell.sell.price' />}
              style={{ textAlign: 'center', background: '#f3f3f3' }}
            >
              <Tooltip title='Click to change price' color='#6f6e6e'>
                {/* <Tooltip
                title='Press Enter to make change (IF FIX TAX IS ENABLE THEN IT WILL APPLY TO THE ENTERED AMOUNT)'
                color='#6f6e6e'
              > */}
                <Row
                  justify='center'
                  onClick={() => clickForNumPad(NumPadTypes.PRICE, data)}
                >
                  <Col style={{ cursor: 'pointer' }}>{getAmount}</Col>
                </Row>
                {}
              </Tooltip>
            </Form.Item>
            {Math.sign(data.displayMarkupPercent) == -1 ? (
              <Form.Item
                className='ant-form-item-label-custom  disp-table-cell Sub-ProductQuantity'
                name={`ProductMarkup${data.key}`}
                label={<IntlMessages id='sell.sell.markuppercentage' />}
                style={{ textAlign: 'center', background: '#f3f3f3' }}
              >
                <Row justify='center'>
                  <Col>
                    {formatDigits(
                      data.displayMarkupPercent * -1,
                      getDefaultDecimalPlaces
                    )}
                  </Col>
                </Row>
              </Form.Item>
            ) : (
              <Form.Item
                className='ant-form-item-label-custom  disp-table-cell Sub-ProductQuantity'
                style={{ textAlign: 'center', background: '#f3f3f3' }}
                name={`ProductDiscount${data.key}`}
                label={<IntlMessages id='sell.sell.discount' />}
              >
                <Tooltip title='Click to apply discount' color='#6f6e6e'>
                  {/* <Tooltip title='Press Enter to make change' color='#6f6e6e'> */}
                  <Row
                    justify='center'
                    onClick={() => clickForNumPad(NumPadTypes.DISCOUNT, data)}
                  >
                    <Col style={{ cursor: 'pointer' }}>{getDiscount}</Col>
                  </Row>
                  {/* <Input
                    placeholder='0'
                    value={getDiscount}
                    // defaultValue={data.displayDiscountPercent}
                    onPressEnter={e => {
                      setActionLog(
                        e.target.value,
                        data.key,
                        SALE_ACTION_LOG.ItemDiscount,
                        data.productName
                      )
                      handleChangeProductRowFields(
                        e,
                        'ProductDiscount',
                        data.key,
                        key
                      )
                    }}
                    onChange={e => {
                      setDiscount(e.target.value)
                    }}
                    onBlur={e => {
                      if (width <= 768 || isMobile) {
                        setActionLog(
                          e.target.value,
                          data.key,
                          SALE_ACTION_LOG.ItemDiscount,
                          data.productName
                        )
                        handleChangeProductRowFields(
                          e,
                          'ProductDiscount',
                          data.key,
                          key
                        )
                      }
                    }}
                    disabled={
                      data.isOnAccount || data.isRefund || !discountPerm
                    }
                    onFocus={e => e.target.select()}
                  /> */}
                </Tooltip>
              </Form.Item>
            )}
          </InputGroup>
          {data.negativeInventory && (
            <p style={{ marginTop: -12, color: 'red' }}>
              <IntlMessages
                id='sell.cart.inventory.msg'
                description='Inventory out of stock'
                defaultMessage='Your inventory is out of stock'
                values={{
                  strong: chunks => <strong>{chunks}</strong>,
                  invCount:
                    data.currentInventory == null ||
                    data.currentInventory == undefined
                      ? 0
                      : data.currentInventory
                }}
              />{' '}
              <a
                style={{
                  fontWeight: 500,
                  textDecoration: 'underline'
                }}
                onClick={() => invContAnyway()}
              >
                <IntlMessages id='sell.cart.inventory.cont' />
              </a>
            </p>
          )}
          <Form.Item
            className='ant-form-item-label-custom Pro-Note'
            name={`ProductNotes${data.key}`}
            // label={<IntlMessages id='sell.sell.notes' />}
          >
            <Input.TextArea
              className='pro-TextArea'
              placeholder='Enter a note about this Product.'
              onBlur={e => {
                handleChangeProductRowFields(e, 'ProductNotes', data.key, key)
              }}
              disabled={data.isOnAccount}
            />
          </Form.Item>
        </Form>
        {isOnline && availableUsers && availableUsers.length > 1 && (
          <Row style={{ marginTop: 10 }}>
            <Col>
              <Popover
                placement='left'
                title={<span>Team Members</span>}
                content={content}
                trigger={'click'}
                visible={popoverVisible}
                onVisibleChange={visible => setPopoverVisible(visible)}
              >
                {availableUsers.filter(
                  a => getDecryptID(a.id) == data.userID
                  // ||
                  //   getDecryptID(a.id) ==
                  //     getDecryptID(
                  //       !isEmptyObject(getReduxStoreInfo)
                  //         ? getReduxStoreInfo.userID
                  //         : ''
                  //     )
                ).length > 0 && (
                  <Button type='primary' disabled={data.isOnAccount}>
                    {`Sold by ${
                      availableUsers.filter(
                        a => getDecryptID(a.id) == data.userID
                      )[0].firstName +
                      ' ' +
                      availableUsers.filter(
                        a => getDecryptID(a.id) == data.userID
                      )[0].lastName
                    }`}
                  </Button>
                )}
              </Popover>
            </Col>
          </Row>
        )}
      </Panel>
    </Collapse>
  )
}

export default ProductObj
